import React from 'react';

import { Typography, PageTitle, LineButton } from "../../components";
import { Instagram } from '../../subpages';
import { Grid } from "@mui/material";

import Document from './Document';

export default function Privacy(props) {
    const documentName = 'Privacyverklaring'

    return (
        <div>
            <PageTitle title={documentName} left='-40px'>
                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Typography variant='h2'>{documentName}</Typography>
                    <Document documentName={documentName} {...props} />
                    <LineButton href='/files/VM_Privacy verklaring.pdf' download={true}>Privacyverklaring downloaden</LineButton>
                </Grid>
            </PageTitle>
            <Instagram {...props} />
        </div>
    )
}